interface IAsyncItem {
    name: string;
    function: (resolve: (item?: any) => void) => void;
}

const items: IAsyncItem[] = [];
const loaded: string[] = [];

export class AsyncService {
    public static register(
        names: string | string[],
        callbacks: ((resolve: (item?: any) => void) => void) | ((resolve: (item?: any) => void) => void)[]
    ): void {
        if (!Array.isArray(names)) {
            names = [names];
        }
        if (!Array.isArray(callbacks)) {
            callbacks = [callbacks];
        }
        names.forEach(name => {
            if (!AsyncService.has(name)) {
                if (Array.isArray(callbacks)) {
                    callbacks.forEach(callback => {
                        items.push({
                            name: name,
                            function: callback
                        });
                    });
                }
            } else {
                console.warn(`Async chunk '${name}' already registered.`);
            }
        });
    }

    public static run(name: string): Promise<any[]> {
        const promises: Promise<any>[] = [];
        items.forEach((item: IAsyncItem) => {
            if (item.name.startsWith(name)) {
                let promise = new Promise<void>(resolve => {
                    item.function(resolve);
                });
                promise = promise.then(result => {
                    loaded.push(name);
                    return result;
                });
                promises.push(promise);
            }
        });
        if (promises.length === 0) {
            console.error('async-service.run: component "' + name + '" requested, but not registered via AsyncService.register');
        }
        return Promise.all(promises);
    }

    public static loaded(name: string): boolean {
        return loaded.includes(name);
    }

    public static runAll(): Promise<any> {
        const promises: Promise<void>[] = [];
        items.forEach(item => {
            promises.push(
                new Promise(resolve => {
                    item.function(resolve);
                })
            );
        });
        return Promise.all(promises);
    }

    public static has(name: string): boolean {
        let ret = false;
        items.forEach(item => {
            if (item.name === name) {
                ret = true;
            }
        });
        return ret;
    }
}
